import React from 'react';
import PropTypes from 'prop-types';
import { P } from 'sushiweb/Typography/Text';
import H6 from 'sushiweb/Typography/Heading/H6';
import Tooltip from 'sushiweb/Tooltip/Tooltip';
import { DetailsContainer } from './styles';
import { InfoLineIcon } from '../../../../components/SVGs/commonSVGs';

const DetailsWrapper = ({
  tooltipDirection,
  showInfoTip,
  tooltipMessage,
  label,
  value,
  subValue,
}) => {
  return (
    <DetailsContainer text={value}>
      <P>
        {label}
        {showInfoTip && (
          <Tooltip
            position={tooltipDirection}
            showTooltip={showInfoTip}
            label={tooltipMessage}
            className='tooltipInfo'
            appearance='light'
            size='small'
            style={{
              marginLeft: '-180px',
              fontSize: '12px',
              padding: '5px',
              borderRadius: '10px',
              opacity: '0.8',
              width: '200px',
            }}
          >
            <InfoLineIcon />
          </Tooltip>
        )}
      </P>
      <H6>
        {value} {subValue && <span>{subValue}</span>}{' '}
      </H6>
    </DetailsContainer>
  );
};

DetailsWrapper.propTypes = {
  tooltipDirection: PropTypes.string,
  showInfoTip: PropTypes.bool,
  tooltipMessage: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  subValue: PropTypes.string,
};

DetailsWrapper.defaultProps = {
  tooltipDirection: 'top',
  showInfoTip: false,
  tooltipMessage: '',
  label: '',
  value: '',
  subValue: '',
};

export default DetailsWrapper;
